import { Box, Divider, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconPalette } from '@tabler/icons-react';
import { usePreferencesStore } from '../../../stores';
import ThemeSwitcher from '../../../components/ui/switchers/ThemeSwitcher';
import ColorSchemeSwitcher from '../../../components/ui/switchers/ColorSchemeSwitcher';
import ColorSchemePreview from '../../../components/ui/ColorSchemePreview';
import SegmentedControl from '../../../components/ui/navigation/SegmentedControl';

export default function AppearanceSection() {
  const colorSchemeKey = usePreferencesStore((state) => state.colorSchemeKey);
  const uiSize = usePreferencesStore((state) => state.uiSize);
  const setUiSize = usePreferencesStore((state) => state.setUiSize);

  return (
    <Stack gap="lg">
      {/* Header */}
      <Group gap="sm">
        <ThemeIcon size="lg" radius="md" variant="light">
          <IconPalette size={20} />
        </ThemeIcon>
        <Box>
          <Text fw={600}>Appearance</Text>
          <Text size="xs" c="dimmed">
            Customize the look and feel
          </Text>
        </Box>
      </Group>

      <Divider />

      {/* Theme Mode */}
      <Box>
        <Text size="sm" fw={500} mb="xs">
          Theme Mode
        </Text>
        <ThemeSwitcher variant="segmented" showLabel size="sm" />
      </Box>

      {/* Live Preview - shown above the picker for immediate visibility */}
      <Box>
        <Text size="sm" fw={500} mb="xs">
          Current Theme Preview
        </Text>
        <ColorSchemePreview schemeKey={colorSchemeKey} size="sm" />
      </Box>

      {/* Color Scheme Selection */}
      <Box>
        <Text size="sm" fw={500} mb="xs">
          Color Scheme
        </Text>
        <Text size="xs" c="dimmed" mb="md">
          Choose a color scheme for the application
        </Text>
        <ColorSchemeSwitcher variant="grid" columns={5} maxHeight={400} />
      </Box>

      {/* UI Size */}
      <Box>
        <Text size="sm" fw={500} mb="xs">
          UI Size
        </Text>
        <SegmentedControl
          fullWidth
          activeGradient
          data={[
            { label: 'Compact', value: 'compact' },
            { label: 'Regular', value: 'regular' },
            { label: 'Comfortable', value: 'comfortable' },
            { label: 'Spacious', value: 'spacious' },
          ]}
          value={uiSize}
          onChange={(value) => setUiSize(value as typeof uiSize)}
        />
      </Box>
    </Stack>
  );
}
